<template>
  <div v-if="currentAbonnement">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Gestion des abonnements'"
          :description="'Aperçu d\'un abonnement'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentAbonnement.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 text-custom-primary">
                    Référence de l'abonnement :
                    {{ currentAbonnement.document.reference }}
                  </td>
                </tr>
                <tr class="d-flex">
                  <td class="col-3 font-weight-bold">Total prévu</td>
                  <td class="col-3 font-weight-bold">Total réel</td>
                  <td class="col-3 font-weight-bold">Total paiements</td>
                  <td class="col-3 font-weight-bold">Total restant</td>
                </tr>
                <tr class="d-flex">
                  <td class="col-3">
                    {{
                      formatWithCurrency(
                        currentAbonnement.total_prevu,
                        currentAbonnement.devise.symbole
                      )
                    }}
                  </td>
                  <td class="col-3">
                    {{
                      formatWithCurrency(
                        currentAbonnement.total_reel,
                        currentAbonnement.devise.symbole
                      )
                    }}
                  </td>
                  <td class="col-3">
                    {{
                      formatWithCurrency(
                        currentAbonnement.total_paiement,
                        currentAbonnement.devise.symbole
                      )
                    }}
                  </td>
                  <td class="col-3">
                    {{
                      formatWithCurrency(
                        currentAbonnement.total_restant,
                        currentAbonnement.devise.symbole
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_abonnement' }).catch(() => {})
          "
        >
          Liste des abonnements
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_abonnement-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvel abonnement
        </button>
        <button
          v-if="currentAbonnement.total_paiement === 0"
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'achat_abonnement-edit',
                params: { id: currentAbonnement.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'achat_abonnement-show',
                params: { id: currentAbonnement.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Abonnement</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'achat_abonnement_show-document',
                params: {
                  id: currentAbonnement.id,
                  documentUuid: currentAbonnement.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'achat_abonnement_show-facture',
                params: { id: currentAbonnement.id },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Factures</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      title: 'Gestion des abonnements - Aperçu',
    };
  },
  computed: {
    ...mapGetters('abonnement', ['currentAbonnement']),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('abonnement', ['getAbonnement']),
    init() {
      this.getAbonnement(this.$route.params.id);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
